var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgControlLifeIcn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "control_life_icn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "control_life_icn"
  }, /*#__PURE__*/React.createElement("g", {
    id: "control-own-life-icon",
    transform: "translate(16.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 26.373626)",
    stroke: "#000000",
    strokeWidth: 1.97999999
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7650575,32.9462898 L23.7650575,66.1705383 L6.2523992,66.1705383 C4.55340996,66.1705383 3.11580369,64.862497 2.85442073,63.1620434 L0.371282613,36.6088054 C0.240591133,34.6467434 1.67819741,32.9462898 3.76926108,32.9462898 L23.7650575,32.9462898 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7650575,66.1705383 L48.3350556,72.5799406 C51.0795767,73.3647654 53.9547893,73.6263736 56.8300018,73.6263736 L68.7229265,73.6263736 C71.9902135,73.6263736 74.7347345,71.2718993 75.3881919,68.1326002 L81.138617,35.6931765 C81.9227659,31.5074444 78.6554789,27.7141246 74.4733516,27.7141246 L58.2676081,27.7141246 C55.78447,27.7141246 54.2161722,25.2288462 55.1310126,23.005176 L58.1369166,16.3341655 C58.9210655,14.5029077 59.3131399,12.5408458 59.3131399,10.5787839 L59.1824485,5.21581461 C59.1824485,2.33812379 56.8300018,0.114453612 53.9547893,0.24525774 L53.9547893,0.24525774 C51.2102682,0.24525774 48.988513,2.59973205 48.988513,5.34661874 L48.988513,7.0470724 C48.988513,9.40154671 48.2043642,11.6252169 46.7667579,13.3256706 L33.436227,30.1994031 C32.1293122,31.8998567 30.16894,32.9462898 27.9471848,32.9462898 L23.7650575,32.9462898",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55,0.43377675 L55,16.0497397",
    id: "Line-2",
    stroke: "#B7B9BB",
    strokeWidth: 1.75999993,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,6.59340659 L40.8,15.3846154",
    id: "Line-2",
    stroke: "#B7B9BB",
    strokeWidth: 1.75999993,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2,6.59340659 L78,15.3846154",
    id: "Line-2",
    stroke: "#B7B9BB",
    strokeWidth: 1.75999993,
    strokeLinecap: "square",
    transform: "translate(73.600000, 10.989011) scale(-1, 1) translate(-73.600000, -10.989011) "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlLifeIcn);
export default __webpack_public_path__ + "static/media/control_life_icn.4ed9e4ddad879eed06e851150bfe048e.svg";
export { ForwardRef as ReactComponent };